import type { Room } from "@/react/types/Live/Room";
import {
  isBackstage,
  isLive,
} from "@circle-react/helpers/liveStreamRoomHelpers";

export const getRoomRefetchInterval = (room?: Room) => {
  if (room && (isBackstage(room) || !room?.hls_url)) {
    // 10 seconds
    return 10 * 1000;
  }
  if (isLive(room)) {
    // 1 minute
    return 60 * 1000;
  }
  return null;
};
